import useObjectEditStore from "../../store/useObjectEditStore";
import {useTranslation} from "next-i18next";
import BoldButton from "./buttons/BoldButton";
import ItalicButton from "./buttons/ItalicButton";
import AlignSelect from "./select/AlignSelect";
import SizeSelect from "./select/SizeSelect";
import FontSelect from "./select/FontSelect";
import ColorPicker from "./select/ColorPicker";
import DeleteButton from "./buttons/DeleteButton";
import {useMemo} from "react";
import useEditorPanelButtonStore from "../../store/useEditorPanelButtonStore";

const editorPanel = {
  'edit':
    <>
      <BoldButton/>
      <ItalicButton/>
      <AlignSelect/>
      <SizeSelect/>
      <FontSelect/>
      <ColorPicker/>
      <DeleteButton/>
    </>,
  'sign': <DeleteButton/>,
  'image': <DeleteButton/>,
  'form': <DeleteButton/>,
}

const EditorPanel = () => {
  const {t} = useTranslation();
  const objectEditStore = useObjectEditStore();
  const editorPanelButtonStore = useEditorPanelButtonStore();
  const element = useMemo(() => {
    return objectEditStore.objectEdit ? objectEditStore.objectEdit.element : null
  }, [objectEditStore.objectEdit])

  return (
    element
      ?
      <div className="pdf-editor__edit-text">
        {editorPanel[editorPanelButtonStore.tab]}
      </div>
      :
      <span className="pdf-editor__header-hint">{t("convert-and-edit:editor.edit-hint")}</span>
  );
};

export default EditorPanel;
